"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var BillingLineUtility_1 = require("../../../utils/BillingLineUtility");
var api_1 = require("@unimaze/api-clients/lib/mapi/api");
var react_intl_1 = require("react-intl");
var CommonTranslations_1 = require("../CommonTranslations");
var IntlUtility_1 = require("../../../utils/IntlUtility");
var translationMessages = react_intl_1.defineMessages({
    billingTaxSummary_taxOverview: {
        id: "billingTaxSummary_taxOverview",
        defaultMessage: "Tax overview"
    },
    billingTaxSummary_taxableAmount: {
        id: "billingTaxSummary_taxableAmount",
        defaultMessage: "Taxable amount"
    },
    billingTaxSummary_taxAmount: {
        id: "billingTaxSummary_taxAmount",
        defaultMessage: "Tax"
    },
    billingTaxSummary_taxCategoryType_labels_StandardRated: {
        id: "billingTaxSummary_taxCategoryType_labels_StandardRated",
        defaultMessage: "Standard rated",
    },
    billingTaxSummary_taxCategoryType_labels_ReducedRated: {
        id: "billingTaxSummary_taxCategoryType_labels_ReducedRated",
        defaultMessage: "Reduced rated",
    },
    billingTaxSummary_taxCategoryType_labels_ZeroRated: {
        id: "billingTaxSummary_taxCategoryType_labels_ZeroRated",
        defaultMessage: "Zero rated",
    },
    billingTaxSummary_taxCategoryType_labels_Exempt: {
        id: "billingTaxSummary_taxCategoryType_labels_Exempt",
        defaultMessage: "Exempt",
    },
    billingTaxSummary_taxCategoryType_labels_OutsideTaxScope: {
        id: "billingTaxSummary_taxCategoryType_labels_OutsideTaxScope",
        defaultMessage: "Outside tax scope",
    },
});
var BillingTaxSummary = function (props) {
    var _a = react_1.useState(props.formInstance.getFieldValue(["invoice", "invoiceLines"])), invoiceLines = _a[0], setInvoiceLines = _a[1];
    react_1.useEffect(function () {
        setInvoiceLines(props.formInstance.getFieldValue(["invoice", "invoiceLines"]));
    }, [props.outsideVatScope, props.formInstance.getFieldValue(["invoice", "invoiceLines"])]);
    var dataSource = invoiceLines
        ? invoiceLines.map(function (billingLine) {
            var taxCategoryType = billingLine.taxCategoryType ? api_1.TaxCategoryTypeEnum[billingLine.taxCategoryType] : undefined;
            var translationString = "taxCategoryType_labels_" + taxCategoryType;
            var taxCategoryTypeTranslated = CommonTranslations_1.commonTranslationMessages.hasOwnProperty(translationString)
                ? props.intl.formatMessage(CommonTranslations_1.commonTranslationMessages[translationString])
                : "";
            return {
                taxOverview: BillingLineUtility_1.generateTaxCategoryLabel(taxCategoryType, taxCategoryTypeTranslated),
                taxableAmount: BillingLineUtility_1.calculateTaxableAmount(billingLine.discountValue, billingLine.quantity, billingLine.unitPriceAmount),
                taxAmount: BillingLineUtility_1.calculateTaxAmount(BillingLineUtility_1.calculateTaxableAmount(billingLine.discountValue, billingLine.quantity, billingLine.unitPriceAmount), BillingLineUtility_1.calculateTaxPercentage(billingLine.taxCategoryType ? api_1.TaxCategoryTypeEnum[billingLine.taxCategoryType] : undefined))
            };
        })
        : [];
    var hlpArray = dataSource ? dataSource.slice() : [];
    var helper = {};
    var result = hlpArray.reduce(function (r, o) {
        var key = o.taxOverview;
        if (!helper[key]) {
            helper[key] = Object.assign({}, o); // create a copy of o
            r.push(helper[key]);
        }
        else {
            helper[key].taxAmount += o.taxAmount;
            helper[key].taxableAmount += o.taxableAmount;
        }
        return r;
    }, []);
    var columns = [
        {
            title: props.intl.formatMessage(translationMessages.billingTaxSummary_taxOverview),
            dataIndex: "taxOverview",
        },
        {
            title: props.intl.formatMessage(translationMessages.billingTaxSummary_taxableAmount),
            dataIndex: "taxableAmount",
            render: function (value, record) {
                return IntlUtility_1.icelandicNumberLocaleWorkaroundChrome(record.taxableAmount, props.intl, { style: "decimal" });
            }
        },
        {
            title: props.intl.formatMessage(translationMessages.billingTaxSummary_taxAmount),
            dataIndex: "taxAmount",
            render: function (value, record) {
                return IntlUtility_1.icelandicNumberLocaleWorkaroundChrome(record.taxAmount, props.intl, { style: "decimal" });
            }
        },
    ];
    return (react_1.default.createElement(antd_1.Table, { style: { minHeight: "170px" }, 
        // showHeader={false}
        columns: columns, dataSource: result, pagination: false, rowKey: (function (record, index) { return index.toString(); }) }));
};
exports.default = react_intl_1.injectIntl(BillingTaxSummary);
